module.exports = __webpack_public_path__ + "static/media/DL_2.6b80e420.jpg";